import type { Locale } from '@yi/core';

export function getAnalyticIndexName(baseIndexName: string, locale: Locale) {
  const indexName = `${baseIndexName}_${locale}`;
  return indexName;
}
